import { SearchListDeleteAction } from '@aibees/elephant/components/search-list-delete-action';
import { SearchListEditAction } from '@aibees/elephant/components/search-list-edit-action';
import { useExtractMetadataFromSearchQuerySearchCardValue } from '@aibees/elephant/feature/search-list-card/hooks/use-extract-metadata-from-search-query-search-card-value';
import { useSearchListCardStore } from '@aibees/elephant/feature/search-list-card/store';
import { useDisplaySearchTable } from '@aibees/elephant/hooks/use-display-search-table';
import { IconButton, PopoverListButtonProps } from '@aibees/shared/components';
import { useBoolean } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils/class-names';
import { Stack } from '@mui/material';
import { memo } from 'react';
import { SAVED_SEARCH_ACTION_MENU_ITEMS } from './config';
import * as Styled from './styles';
import * as SX from './sx';
import {
  SavedSearchTableActionType as Action,
  type SaveSearchTableActionProps as Props,
} from './types';

const ANCHOR_ORIGIN = {
  vertical: 'bottom',
  horizontal: 'right',
} as const;
const TRANSFORM_ORIGIN = {
  vertical: 'top',
  horizontal: 'right',
} as const;

export const SaveSearchTableAction = memo(
  ({ className, item, rowNumber }: Props) => {
    const { setState } = useSearchListCardStore();
    const showSearchResult = useDisplaySearchTable();
    const editSearchState = useBoolean(false);
    const deleteSearchState = useBoolean(false);
    const filteredMenuItems = !item.isMine
      ? SAVED_SEARCH_ACTION_MENU_ITEMS.filter(
          (x) => x.key !== Action.edit && x.key !== Action.delete
        )
      : SAVED_SEARCH_ACTION_MENU_ITEMS;

    const { metadata, path } =
      useExtractMetadataFromSearchQuerySearchCardValue(item);
    if (!metadata?.url) return null;

    const handleViewClick = () => {
      setState(true);

      if (showSearchResult) {
        window.open(path, '_blank');
      }
    };

    const handleSelect: PopoverListButtonProps['onSelect'] = (e) => {
      if (e.key === Action.edit) {
        editSearchState.onTrue();
      } else if (e.key === Action.delete) {
        deleteSearchState.onTrue();
      } else if (e.key === Action.view) {
        setState(true);

        if (showSearchResult) {
          window.open(path, '_blank');
        }
      }
    };

    return (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="center"
        gap={0.5}
      >
        <IconButton
          icon="eye-outlined"
          variant="outlined"
          size="xsmall"
          onClick={handleViewClick}
        />
        <>
          <Styled.Wrapper
            className={classnames('SaveSearchTableAction', className)}
            popoverSx={SX.popover}
            icon="more-horizontal"
            variant="outlined"
            size="xsmall"
            anchorOrigin={ANCHOR_ORIGIN}
            transformOrigin={TRANSFORM_ORIGIN}
            items={filteredMenuItems}
            itemDivider={true}
            onSelect={handleSelect}
          />

          <SearchListEditAction
            state={editSearchState}
            item={item}
            rowNumber={rowNumber}
          />

          <SearchListDeleteAction
            state={deleteSearchState}
            item={item}
            rowNumber={rowNumber}
          />
        </>
      </Stack>
    );
  }
);

SaveSearchTableAction.displayName = 'SaveSearchTableAction';
